export const isAnnotationLocked = (annotation) => Boolean(annotation?.locked);

export const isAnnotationIdLocked = (annotations, id) =>
  Boolean(annotations?.[id]?.locked);

export const selectionHasLockedAnnotation = (annotations, annotationIds = []) =>
  annotationIds.some((id) => isAnnotationIdLocked(annotations, id));

export const filterUnlockedAnnotationIds = (annotations, annotationIds = []) =>
  annotationIds.filter((id) => !isAnnotationIdLocked(annotations, id));
